import Vue from 'vue';

export interface ToastItem {
  id: number;
  type: 'success' | 'error' | 'info';
  message: string;
  duration: number;
}

const state = Vue.observable({
  toasts: [] as ToastItem[],
});

const timers = new Map<number, ReturnType<typeof setTimeout>>();
let nextId = 0;

function addToast(type: 'success' | 'error' | 'info', message: string, duration: number) {
  const id = nextId++;
  state.toasts.push({ id, type, message, duration });
  const timer = setTimeout(() => removeToast(id), duration);
  timers.set(id, timer);
}

export function removeToast(id: number) {
  const idx = state.toasts.findIndex((t) => t.id === id);
  if (idx !== -1) state.toasts.splice(idx, 1);
  const timer = timers.get(id);
  if (timer !== undefined) {
    clearTimeout(timer);
    timers.delete(id);
  }
}

export const toastState = state;

const ToastPlugin = {
  install(VueConstructor: typeof Vue) {
    VueConstructor.prototype.$toast = {
      success(message: string) { addToast('success', message, 3000); },
      error(message: string) { addToast('error', message, 5000); },
      info(message: string) { addToast('info', message, 3000); },
    };
  },
};

export default ToastPlugin;
